import { all, cancel, fork, take } from "redux-saga/effects";
import type { Task } from "redux-saga";

import { rootAppSaga } from "@ds/modules/app/redux/slice";
import { authActions, rootAuthSaga } from "@ds/modules/auth/redux/slice";
import { rootAssetsCommonSaga } from "@ds/modules/assets/redux/common-slice";
import { rootAssetsSaga } from "@ds/modules/assets/redux/slice";
import { rootCampaignItemsSaga } from "@ds/modules/content/campaign-items/redux/slice";
import { rootCampaignsSaga } from "@ds/modules/content/campaigns/redux/slice";
import { rootPlaylistAssetsSaga } from "@ds/modules/content/playlist-assets/redux/slice";
import { rootPlaylistsSaga } from "@ds/modules/content/playlists/redux/slice";
import { rootContentSaga } from "@ds/modules/content/redux/slice";
import { rootDeploymentsSaga } from "@ds/modules/deployments/redux/slice";
import { rootDeviceSyncsSaga } from "@ds/modules/device-syncs/redux/slice";
import { rootPeripheralsSaga } from "@ds/modules/devices/peripherals/redux/slice";
import { rootPlayersSaga } from "@ds/modules/devices/players/redux/slice";
import { rootDevicesSaga } from "@ds/modules/devices/redux/slice";
import { rootExperiencesSaga } from "@ds/modules/experiences/redux/slice";
import { rootFeaturesSaga } from "@ds/modules/features/redux/slice";
import { rootIoTSaga } from "@ds/modules/iot/redux/sagas";
import { rootLocationsSaga } from "@ds/modules/locations/redux/slice";
import { rootInvitationsSaga } from "@ds/modules/settings/invitations/redux/slice";
import { rootProjectsSaga } from "@ds/modules/settings/projects/redux/slice";
import { rootSettingsSaga } from "@ds/modules/settings/redux/slice";
import { rootUsersSaga } from "@ds/modules/settings/users/redux/slice";
import { rootTableDataSaga } from "@ds/modules/table-data/redux/slice";

function* allModuleSagas() {
  yield all([
    rootExperiencesSaga(),
    rootDevicesSaga(),
    rootPlayersSaga(),
    rootPeripheralsSaga(),

    rootLocationsSaga(),

    rootContentSaga(),
    rootCampaignsSaga(),
    rootCampaignItemsSaga(),
    rootPlaylistsSaga(),
    rootPlaylistAssetsSaga(),

    rootAssetsCommonSaga(),
    rootAssetsSaga(),

    rootDeploymentsSaga(),
    rootDeviceSyncsSaga(),

    rootSettingsSaga(),
    rootProjectsSaga(),
    rootUsersSaga(),
    rootInvitationsSaga(),
    rootFeaturesSaga(),

    rootTableDataSaga(),
    rootIoTSaga(),
  ]);
}

function* modulesSaga() {
  let task: Task = yield fork(allModuleSagas);

  while (true) {
    // ORDERING DEPENDENCY: rootAppSaga (which registers onSignOut via takeLeading on signOutSucceeded)
    // must appear before modulesSaga in the all([...]) array in rootSaga(). onSignOut calls
    // api.cancelPending() synchronously, which must complete before yield cancel(task) tears down
    // module sagas. Changing the order in rootSaga() would break this guarantee.
    yield take(authActions.signOutSucceeded);
    yield cancel(task);

    // Safe: we only reach this take after a signOutSucceeded, so any
    // fetchAuthenticatedCognitoUserSucceeded at this point represents a real re-login.
    yield take(authActions.fetchAuthenticatedCognitoUserSucceeded);
    task = yield fork(allModuleSagas);
  }
}

export function* rootSaga() {
  // ORDER MATTERS: rootAppSaga must precede modulesSaga — see modulesSaga for the ordering contract.
  yield all([rootAppSaga(), rootAuthSaga(), modulesSaga()]);
}
